import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MasterTabsComponent } from './master-tabs.component';
import { MaterialModule } from "src/app/shared/material/material.module";
import { RouterModule, RouterOutlet } from '@angular/router';
import { Masterroutes } from './master.routes';
import { CargoComponent } from './pages/cargo/cargo.component';
import { ClientComponent } from './pages/client/client.component';
import { PortAgentComponent } from './pages/port-agent/port-agent.component';
import { PortComponent } from './pages/port/port.component';
import { PurposeComponent } from './pages/purpose/purpose.component';
import { TariffServicesComponent } from './pages/tariff-services/tariff-services.component';
import { VesselComponent } from './pages/vessel/vessel.component';



@NgModule({
  declarations: [
    MasterTabsComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    RouterOutlet,
     RouterModule.forChild(Masterroutes)
]
})
export class MasterTabsModule { }
